export type RelayIntent = "appreciate" | "encourage" | "reconnect";

export const RELAY_INTENTS: Array<{
  key: RelayIntent;
  emoji: string;
  title: string;
  subtitle: string;
}> = [
  { key: "appreciate", emoji: "💛", title: "Someone I appreciate", subtitle: "Tell them why they matter" },
  { key: "encourage", emoji: "🌟", title: "Someone who needs encouragement", subtitle: "Give them a lift today" },
  { key: "reconnect", emoji: "👋", title: "Someone I miss", subtitle: "Make the first move" },
];

const MESSAGE_OPTIONS: Record<RelayIntent, string[]> = {
  appreciate: [
    "I appreciate you more than I probably say. This banana is your reminder.",
    "You make a real difference in my life. Thank you for being you.",
    "You crossed my mind today, and I wanted you to know how much I value you.",
  ],
  encourage: [
    "You have more strength than this moment. Keep going — I believe in you.",
    "A small banana with a big reminder: you've got this.",
    "I'm in your corner. One step at a time, and you don't have to do it alone.",
  ],
  reconnect: [
    "It's been too long. I miss you and wanted to send a little hello.",
    "No big reason — you crossed my mind, and I'm glad you did.",
    "Life gets busy, but you still matter to me. Let's reconnect soon.",
  ],
};

export const getSuggestedMessages = (intent: RelayIntent): string[] => MESSAGE_OPTIONS[intent];

export const getDefaultMessage = (intent: RelayIntent): string => MESSAGE_OPTIONS[intent][0];

